import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import ReCAPTCHA from "react-google-recaptcha";
// import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";

// Validation Hepers
import { validate } from "helpers/validations";
import { validateEmail } from "helpers/EmailValidation";

// Store
import { newsletter } from "store/actions";

export default function Reportcenter() {
  const dispatch = useDispatch();

  const { settings } = useSelector((state) => state?.Login);
  const [isVerified, setIsVerified] = useState(false);
  const [fields, setFields] = useState({
    email: "",
  });

  const { email, emailError } = fields;

  const onChangeHandler = (e) => {
    e.persist();
    const { value, name } = e.target;
    setFields((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );
  };

  function handleVerify(response) {
    if (response) {
      setIsVerified(true);
    }
  }

  const onSubmit = (e) => {
    e.preventDefault();
    let response = validate(fields);
    setFields((prev) => ({ ...prev, ...response }));
    let data = { email };
    if (!validateEmail(email)) {
      toastr.error("Email is not valid.");
      return;
    }
    if (isVerified) {
      const callback = (res) => {
        const { message, status } = res;
        if (status == "failure") {
          toastr.error(message);
        } else {
          toastr.success(message);
          setFields({ email: "" });
        }
      };
      dispatch(newsletter(data, callback));
    } else {
      toastr.error("Please verify that you are not a robot.");
    }
  };

  return (
    <section className="Browsemuseums Reportcenter">
      <Container>
        <div className="Browsemuseums-para Reportcenter">
          <div className="DigitalArtcollection-head text-center">
            <h2>SIGN UP FOR OUR NEWSLETTER</h2>
            <p>
              Sign up to get interesting news and updates delivered to your
              inbox.
            </p>

            <div className="email-newsletter">
              <Form onSubmit={onSubmit} className="newsletters">
                <FormGroup className="position-relative">
                  <Label htmlFor="exampleEmail">Email</Label>
                  <Input
                    type="email"
                    name="email"
                    value={email}
                    invalid={emailError}
                    required={emailError}
                    onChange={onChangeHandler}
                    placeholder="Enter your email id"
                  />
                  <Button disabled={!isVerified} className="btn-send">
                    Send
                  </Button>
                </FormGroup>

                <ReCAPTCHA
                  sitekey={
                    settings?.googleCaptchaKey?.captchaKey ||
                    "6LfHhHgmAAAAAMDY7S-sxLljqfIE6ku1u1zYWNi2"
                  }
                  onChange={handleVerify}
                />
              </Form>
            </div>

            <p>
              We are committed to your privacy. By submitting this form, you are
              granting Fine Art Publishing, LLC permission to e-mail you. You
              may unsubscribe via the link found at the bottom of every e-mail.
              E-mails are serviced by Mail Chimp.
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
